import axios from 'axios'
import {Message} from 'element-ui'
import {Notification} from 'element-ui';
import {Loading} from 'element-ui'; // 加载层
import ServiceManager from './serviceManager'; // 加载层
import {getAccessToken} from '@/service/authentication/authentication'; // 加载层
import httpHelper from "./http-helper";

let LOADING_INSTANCE;
let ENABLE_LOADING = true;

const service = axios.create({
  baseURL: process.env.VUE_APP_SECRET_BASE_API, // api的base_url
  timeout: 600000, // request timeout
  withCredentials: true, // default
})

const newServerUrls = ['captcha/slide', 'member/login']

service.interceptors.request.use(
    config => {
      const accessToken = getAccessToken();
      if (accessToken) {
        config.headers['X-Authentication'] = `Bearer ${getAccessToken()}`
      }
      const strings = newServerUrls.filter(url => config.url.indexOf(url) != -1);
      if (config.url.indexOf('esaleb-service') != -1 || strings.length > 0) {
        config.baseURL = process.env.VUE_APP_SECRET_BASE_NEW_API
      }
      console.log(config.baseURL)
      if (ENABLE_LOADING) {
        LOADING_INSTANCE = Loading.service({
          fullscreen: true,
          text: '数据加载中...',
          spinner: 'el-icon-loading'
        });
      }
      return config
    },
    error => {
      Promise.reject(error)
    }
)

const specialUrls = [
  '!service/file/~java/Uploader.upload',
  '/!service/file/~java/Uploader.upload',
  '/esaleb-server/!service/file/~java/Uploader.upload',
  '/esaleb-server/!Rpt/Watch/DataReport/~query/Q_BUSINESSE_BASIC_STATISTICS.getNextOneLevelMember',
  '/esaleb-server/!Rpt/Watch/DataReport/~query/Q_BUSINESSE_BASIC_STATISTICS.getNextAllLevelMember',
  'http://demo.esaleb.com/!service/file/~java/Uploader.upload',
  '//v3.esaleb.com/!service/file/~java/Uploader.upload',
  '//v3.esaleb.com/!Rpt/Watch/DataReport/~query/Q_BUSINESSE_BASIC_STATISTICS.getNextOneLevelMember',
  '//v3.esaleb.com/!Rpt/Watch/DataReport/~query/Q_BUSINESSE_BASIC_STATISTICS.getNextAllLevelMember',

  // 会员区域
  '/esaleb-server/!System/Core/Member/~query/Q_AREA_TREE_LIST',
  'http://demo.esaleb.com/!System/Core/Member/~query/Q_AREA_TREE_LIST',
  '//v3.esaleb.com/!System/Core/Member/~query/Q_AREA_TREE_LIST',
  // 人员管理-获取会员树
  '/esaleb-server/!org/user/~query/Q_USER_GROUP.Q_MEMBER_TREE',
  'http://demo.esaleb.com/!org/user/~query/Q_USER_GROUP.Q_MEMBER_TREE',
  '//v3.esaleb.com/!org/user/~query/Q_USER_GROUP.Q_MEMBER_TREE',
  // 人员管理-根据用户id获取用户信息
  '/esaleb-server/!org/user/~query/Q_USER_GROUP.USER_INFO',
  'http://demo.esaleb.com/!org/user/~query/Q_USER_GROUP.USER_INFO',
  '//v3.esaleb.com/!org/user/~query/Q_USER_GROUP.USER_INFO',
  // 角色管理-根据角色获取用户拥有的功能权限 (根据点击左边的角色获取右面要显示勾选数据) 
  '/esaleb-server/!sys/menu/~query/Q_MENUS_FUNCTION.Q_MENUS_FUNCTION_BY_ROLE',
  'http://demo.esaleb.com/!sys/menu/~query/Q_MENUS_FUNCTION.Q_MENUS_FUNCTION_BY_ROLE',
  '//v3.esaleb.com/!sys/menu/~query/Q_MENUS_FUNCTION.Q_MENUS_FUNCTION_BY_ROLE',
  // 角色管理-确定授权    
  '/esaleb-server/!sys/security/~query/GET_ALL_ACCESS',
  'http://demo.esaleb.com/!sys/security/~query/GET_ALL_ACCESS',
  '//v3.esaleb.com/!sys/security/~query/GET_ALL_ACCESS',
  // 角色管理-根据角色返回用户数    
  '/esaleb-server/!org/usergroup/~query/Q_USERGROUP_INFO.GET_USER_COUNT_BY_CODE',
  'http://demo.esaleb.com/!org/usergroup/~query/Q_USERGROUP_INFO.GET_USER_COUNT_BY_CODE',
  '//v3.esaleb.com/!org/usergroup/~query/Q_USERGROUP_INFO.GET_USER_COUNT_BY_CODE',
]

var checkSpecialUrl = (url) => {
  return specialUrls.indexOf(url) != -1
}


/**
 * 校验是否合法JSON
 * @param str
 * @returns {boolean}
 */
function isJSON(str) {
  // 如果参数类型是string，则进行JSON.parse，如果不是合法的json字符串会抛出，代表不是合法的json
  if (typeof str == 'string') {
    try {
      JSON.parse(str);
    } catch (e) {
      console.log('error：' + str + '!!!' + e);
      return false;
    }
  }
  return true;
}

// respone interceptor
service.interceptors.response.use(
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    response => {
      // 关闭遮罩层
      if (LOADING_INSTANCE) {
        setTimeout(() => LOADING_INSTANCE.close(), 300);
      }
      let res = response.data

      if (response.headers['content-type'] == 'image/jpeg') {
        return Promise.resolve(response)
      }

      let code;
      let msg;
      if (res.header) {
        code = res.header.code
        msg = res.header.message
      } else {
        code = res.code
        msg = res.msg
      }

      // 有些老接口的返回格式没统一，故不做code校验，直接将返回结果原样输送到组件中进行处理
      var checkSpecialUrl1 = checkSpecialUrl(response.config.url);
      if (checkSpecialUrl1) {
        return Promise.resolve(res)
      }

      // code不等于情况，业务请求使用catch处理
      if (code != 0) {
        httpHelper.handleBusiError(res)
        return Promise.reject(res)
      }
      // 无论成功失败都要把结果返回
      res = JSON.parse(JSON.stringify(res))
      return Promise.resolve(res)
    },
    error => {
      console.log('error', error)
      console.log(error.response)
      if (error && error.response) {
        const respStatus = error.response.status
        switch (respStatus) {
          case 401:
            window.location.href = process.env.VUE_APP_SECRET_LOGIN_URL``
            httpHelper.handleSystemError(error.response.data.msg);
            break;
          case 400:
            httpHelper.handleSystemError(error)
            break;
          case 403:
            window.location.href = process.env.VUE_APP_SECRET_LOGIN_URL
            httpHelper.handleSystemError(error.response.data.msg)
            break;
          case 500:
            console.log('500000000')
            httpHelper.handleSystemError(error.response.data.msg)
            break;
          default:
            break
        }
      }
      console.log(LOADING_INSTANCE)
      if (LOADING_INSTANCE) {
        setTimeout(() => LOADING_INSTANCE.close(), 300);
      }
      return Promise.reject(error);
    }
)

function errorTip(errMsg) {
  Message({
    message: errMsg,
    type: 'error',
    duration: 1000
  })
}

function request(config) {
  const apiPrefix = config.url.substr(0, config.url.indexOf('/'))
  if (ServiceManager.getServices().indexOf(apiPrefix) != -1) {
    let serviceManagerElement = ServiceManager.obtainService(apiPrefix)
    config.url = config.url.replace(apiPrefix, serviceManagerElement)
  }

  let configuration = {
    url: config.url,
    method: config.method,
    // data: config.data || {},
    // headers: config.headers || {'Content-Type': 'application/json;charset=UTF-8'}
  };
  if (configuration.method == 'POST' || configuration.method == 'PUT') {
    configuration.data = config.data || {}
    configuration.headers = config.headers ||{'Content-Type': 'application/json;charset=UTF-8'}
  }
  if (configuration.method == 'GET') {
    configuration.params = config.data
  }
  config.loading = config.loading === undefined ? true : config.loading;
  ENABLE_LOADING = config.loading;
  return service(configuration)
}

export function post(config) {
  config.method = 'POST'
  return request(config)
}

export function get(config) {
  config.method = 'GET'
  return request(config)
}

export function put(config) {
  config.method = 'PUT'
  return request(config)
}

export function del(config) {
  config.method = 'DELETE'
  return request(config)
}

export function upload(config) {
  config.method = 'POST'
  return request(config)
}

export default service
